(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["article-starter-offer"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__mcsStarterOffersInitialized) return;
    window.__mcsStarterOffersInitialized = true;

    const initializeStarterOffers = () => {
      const offers = document.querySelectorAll('[data-mcs-starter-offer]');

      const publish = (eventName, offer) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: eventName,
          starter_offer_intent: offer.dataset.intent,
          starter_offer_placement: offer.dataset.placement,
          starter_offer_content: offer.dataset.contentHandle,
          starter_offer_content_type: offer.dataset.contentType
        });
      };

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !entry.target.dataset.mcsImpressionSent) {
              entry.target.dataset.mcsImpressionSent = 'true';
              publish('starter_offer_impression', entry.target);
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.5 });

        offers.forEach((offer) => observer.observe(offer));
      } else {
        offers.forEach((offer) => {
          if (!offer.dataset.mcsImpressionSent) {
            offer.dataset.mcsImpressionSent = 'true';
            publish('starter_offer_impression', offer);
          }
        });
      }

      document.addEventListener('click', (event) => {
        const link = event.target.closest('[data-mcs-starter-offer-link]');
        if (!link) return;
        const offer = link.closest('[data-mcs-starter-offer]');
        if (offer) publish('starter_offer_click', offer);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeStarterOffers, { once: true });
    } else {
      initializeStarterOffers();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
